import { Component, Input, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ModalController, IonButton, IonCheckbox, IonContent, IonFooter, IonHeader, IonItem, IonLabel, IonRadio, IonRadioGroup, IonSearchbar, IonText, IonToolbar } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { PlatformModeContentDirective } from '../../../../../directive/platform-mode-content.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterNamePipe } from 'src/pipes/filter-name.pipe';

@Component({
    selector: 'app-popup-search-select',
    templateUrl: './popup-search-select.component.html',
    styleUrls: ['./popup-search-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonCheckbox, IonContent, IonFooter, IonHeader, IonItem, IonLabel, IonRadio, IonRadioGroup, IonSearchbar, IonText, IonToolbar, FormsModule, PlatformModeContentDirective, TranslatePipe, FilterNamePipe]
})
export class PopupSearchSelectComponent implements OnInit {
    private readonly _modalCtrl = inject(ModalController);

    @Input() description: string = "";
    @Input() displaySearchBar: boolean = true;
    @Input() searchBarPlaceholder: string = ""
    @Input() items: Array<{ name: string, value: number, subtitle?: string }> = null;
    @Input() selectedItem: { name: string, value: number, subtitle?: string } = null;
    @Input() multipleSelection: boolean = false;
    @Input() selectedItems: { name: string, value: number, subtitle?: string }[] = null;

    public searchTerm = '';

    ngOnInit() {

        //Select first item of the list if selectedItem is null
        if (!this.selectedItem) {
            this.selectedItem = { ...this.items[0] }
        }
    }

    /** Handle click on item */
    public onClickSelectItem(item: { name: string, value: number, subtitle?: string }): void {
        this.selectedItem = item;
    }

    /**
     * Handle multiple items selection
     * @param item selected item
     * @param event checkbox event
     */
    public onChangeSelectItems(item: { name: string, value: number, subtitle?: string }, event: Event): void {
        if ((event as CustomEvent).detail.checked) {
            this.selectedItems = [...this.selectedItems, item];
        } else {
            this.selectedItems = this.selectedItems.filter(listItem => listItem.value !== item.value);
        }

    }

    /**
     * Handle choice when user clicks ok in modal
     */
    public onClickConfirmChoice(): void {

        if (!this.multipleSelection) {
            this._modalCtrl.dismiss({
                selectedValue: this.selectedItem.value,
                selectedName: this.selectedItem.name,
            });
        } else {
            this._modalCtrl.dismiss(this.selectedItems);
        }
    }

    /**
     * Dismiss modal
     */
    public onClickDismiss(): void {
        this._modalCtrl.dismiss();
    }

    /**
     * Add checked status if a particular item is selected (only for multiple selection)
     * @param itemToCheck item to confron
     * @returns true if checked, otherwise false
     */
    public isCheckboxChecked(itemToCheck: { value: number, name: string, subtitle?: string }): boolean {
        return this.selectedItems.some(item => item.value === itemToCheck.value);
    }
}